import { useState } from "react";

/** This release displays no provider/cache output, including forged sentiment values. */
export default function StaffReflectionThemes() {
  const [portfolio, setPortfolio] = useState("Core");
  return <section aria-labelledby="reflection-themes-title" className="rounded-lg border border-pd-rule bg-pd-white p-5">
    <h2 id="reflection-themes-title" className="font-display text-2xl">Staff reflection themes and sentiment</h2>
    <label className="mt-4 flex flex-wrap items-center gap-3 text-sm">Reflection portfolio
      <select className="rounded border border-pd-rule bg-pd-white p-2" value={portfolio} onChange={event => setPortfolio(event.target.value)}>
        <option>Core</option><option>Advanced</option>
      </select>
    </label>
    <p className="mt-3 text-sm text-pd-slate">Whole-school themes require at least five eligible contributors to each question after redaction. Small and related groups are withheld.</p>
    <p className="mt-3 text-sm text-pd-slate">Summaries will be collective paraphrases, never staff quotations.</p>
    <p className="mt-3 text-sm text-pd-slate">Positive, mixed and concerned sentiment is an aggregate inference for school leaders only. It is excluded from governors’ reports.</p>
  </section>;
}
